class Boundary {
    constructor() {
        this.bBox = new THREE.Box3();
    }

    updateBoundingBox() {
        throw 'Subclass responsibility';
    }

    boundingBox() {
        return this.bBox;
    }

    isInside(point) {
        const box = this.boundingBox();
        return box.containsPoint(point);
    }

    getBoundingBox() {
        return this.bBox;
    }
}

export default Boundary;
